// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__X3BLJ","filters_close":"FiltersBlock_filters_close__56CZl"};